import { all } from "redux-saga/effects";
import authSagas from "../modules/auth/saga";
import profileSagas from "../modules/profile/saga";
import propertySagas from "../modules/brands/saga";
import mortgageSagas from "../modules/mortgage/saga";
import reservationSagas from "../modules/reservation/saga";
import dashboardSagas from "../modules/dashboard/saga";
import resourcesSagas from "../modules/resources/saga";
import maintainedValues from "../commons/MaintainedValues/saga";
import marketingPartnersSagas from "../modules/dashboard/pages/marketing/saga";
import ebookingSagas from '../modules/dashboard/pages/e-booking/saga';

export default function* rootSaga() {
  yield all([
    ...authSagas,
    ...profileSagas,
    ...propertySagas,
    ...mortgageSagas,
    ...reservationSagas,
    ...dashboardSagas,
    ...resourcesSagas,
    ...maintainedValues,
    ...marketingPartnersSagas,
    ...ebookingSagas
  ]);
}
